import { FC } from 'react'
import Styles from './Header.module.scss'

const Header: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={Styles.root}>{children}</div>
}

export { Header }
